import { toast } from "react-toastify";

export const completeAuthentication = (authData, setUser, navigate, t) => {
  if (!authData.token) {
    console.error("Authentication failed: No token received");
    toast.error(t("loginErrorOther") || "Bejelentkezési hiba");
    return;
  }

  const {
    token,
    userId,
    roles,
    lastname,
    firstname,
    company_id,
    companyname,
    language,
    timezone_offset,
  } = authData;

  // Update context
  setUser({
    token,
    userId,
    roles,
    lastname,
    firstname,
    company_id,
    companyname,
    language,
    timezone_offset,
  });

  // Store in localStorage
  localStorage.setItem("token", token);
  localStorage.setItem("userId", userId);
  localStorage.setItem("roles", roles);
  localStorage.setItem("lastname", lastname);
  localStorage.setItem("firstname", firstname);
  localStorage.setItem("company_id", company_id);
  localStorage.setItem("companyname", companyname);
  localStorage.setItem("language", language);
  localStorage.setItem("timezone_offset", timezone_offset);

  toast.success(t("loginSuccess"));

  // Navigate to dashboard
  setTimeout(() => {
    navigate("/dashboard");
  }, 1500);
};